
export const TotalPhaseIcon = () => {
    return <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="25" height="26" viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet">
   <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
   fill="#3571ff" stroke="none">
   <path d="M1116 964 c-20 -19 -20 -35 -1 -60 11 -15 14 -54 15 -181 l0 -162
   -29 -16 c-16 -8 -38 -26 -49 -40 -19 -25 -22 -25 -155 -25 l-135 0 -35 35
   c-31 31 -41 35 -87 35 -46 0 -56 -4 -87 -35 l-35 -35 -133 0 -133 0 -35 35
   c-31 31 -41 35 -86 35 -44 0 -56 -5 -87 -33 -90 -82 -26 -226 96 -214 35 4 51
   13 77 41 l33 36 135 0 c125 0 135 -1 145 -21 15 -28 69 -59 103 -59 41 0 92
   27 107 55 13 25 15 25 152 25 l138 0 32 -36 c83 -90 227 -26 215 94 -5 48 -44
   98 -84 108 -23 6 -23 7 -23 179 0 105 4 176 10 180 14 9 13 48 -2 63 -17 17
   -44 15 -62 -4z"/>
   <path d="M940 836 c-76 -26 -125 -48 -125 -56 0 -13 242 -120 271 -120 11 0
   14 24 14 110 0 98 -2 110 -17 109 -10 0 -74 -20 -143 -43z"/>
   </g>
   </svg>  
}

export const HospitalIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="26"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
        fill="#3571ff"
        stroke="none"
      >
        <path
          d="M556 1265 c-54 -19 -106 -64 -134 -116 l-23 -44 -152 -5 -152 -5 -3
   -62 c-3 -59 -1 -64 23 -75 22 -10 25 -17 25 -64 0 -51 10 -66 38 -57 7 3 12
   24 12 59 l0 54 109 0 c108 0 109 0 115 -26 17 -67 138 -144 226 -144 88 0 209
   77 226 144 6 26 7 26 115 26 l109 0 0 -350 0 -350 -84 0 -85 0 -3 223 c-2 172
   -6 228 -17 240 -12 15 -43 17 -261 17 -218 0 -249 -2 -261 -17 -11 -12 -15
   -68 -17 -240 l-3 -223 -84 0 -85 0 -2 202 c-3 195 -4 203 -23 203 -19 0 -20
   -8 -23 -202 -2 -200 -3 -202 -25 -205 -18 -2 -23 -10 -25 -47 -2 -25 -10 -54
   -18 -65 -16 -24 -19 -89 -4 -117 10 -18 27 -19 570 -19 543 0 560 1 570 19 15
   28 12 93 -4 117 -8 11 -16 40 -18 65 -2 37 -7 45 -25 47 l-23 3 0 348 0 348
   25 11 c24 11 26 16 23 75 l-3 62 -152 5 -152 5 -24 45 c-55 105 -187 156 -301
   115z m194 -69 c59 -39 85 -89 85 -166 0 -78 -26 -127 -88 -168 -56 -37 -153
   -39 -210 -3 -76 47 -111 140 -88 229 14 51 75 117 123 131 53 16 135 6 178
   -23z m-360 -171 l0 -25 -125 0 -125 0 0 25 0 25 125 0 125 0 0 -25z m750 0 l0
   -25 -125 0 -125 0 0 25 0 25 125 0 125 0 0 -25z m-530 -560 l0 -215 -95 0 -95
   0 0 215 0 215 95 0 95 0 0 -215z m250 0 l0 -215 -95 0 -95 0 0 215 0 215 95 0
   95 0 0 -215z m280 -290 l0 -25 -500 0 -500 0 0 25 0 25 500 0 500 0 0 -25z
   m20 -100 l0 -25 -520 0 -520 0 0 25 0 25 520 0 520 0 0 -25z"
        />
        <path
          d="M582 1167 c-6 -6 -13 -24 -17 -40 -5 -19 -13 -27 -30 -27 -34 0 -47
   -23 -43 -77 3 -43 6 -49 34 -62 18 -8 37 -27 45 -45 13 -29 17 -31 69 -31 52
   0 56 2 69 31 8 18 27 37 45 45 28 13 31 19 34 62 4 54 -9 77 -43 77 -17 0 -25
   8 -30 27 -11 44 -24 53 -75 53 -26 0 -52 -6 -58 -13z m78 -61 c0 -14 7 -32 16
   -40 8 -9 26 -16 40 -16 19 0 24 -5 24 -25 0 -22 -4 -25 -34 -25 -35 0 -46 -13
   -46 -51 0 -12 -7 -19 -20 -19 -13 0 -20 7 -20 19 0 38 -11 51 -46 51 -30 0
   -34 3 -34 25 0 20 5 25 24 25 31 0 56 25 56 56 0 17 5 24 20 24 15 0 20 -7 20
   -24z"
        />
        <path
          d="M514 486 c-8 -35 4 -66 26 -66 22 0 34 31 26 66 -4 15 -14 24 -26 24
   -12 0 -22 -9 -26 -24z"
        />
        <path
          d="M714 486 c-8 -35 4 -66 26 -66 22 0 34 31 26 66 -4 15 -14 24 -26 24
   -12 0 -22 -9 -26 -24z"
        />
        <path d="M144 755 c-4 -9 -2 -21 4 -27 15 -15 44 -1 40 19 -4 23 -36 29 -44 8z" />
      </g>
    </svg>
  );
};

export const DoctorIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="26"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
        fill="#3571ff"
        stroke="none"
      >
        <path
          d="M565 1269 c-22 -5 -86 -28 -142 -51 -104 -43 -122 -60 -89 -87 13
   -11 13 -17 0 -46 -8 -20 -14 -67 -14 -111 0 -61 -4 -81 -20 -101 -11 -14 -20
   -34 -20 -45 0 -25 44 -68 70 -68 14 0 20 -7 20 -22 0 -30 53 -121 85 -146 17
   -14 25 -30 25 -51 0 -26 -6 -34 -42 -52 -24 -12 -52 -32 -63 -44 -12 -15 -48
   -32 -92 -44 -54 -16 -78 -29 -102 -56 -38 -43 -43 -71 -39 -220 2 -99 6 -120
   18 -120 12 0 16 25 20 148 5 147 5 149 33 173 23 20 143 64 175 64 21 0 22
   -33 2 -55 -27 -29 -25 -45 10 -115 l30 -60 -24 0 c-15 0 -26 7 -29 20 -7 26
   -27 26 -34 1 -4 -16 -15 -21 -52 -23 l-46 -3 0 -75 0 -75 115 0 c112 0 114 0
   120 24 l5 24 12 -27 c13 -27 27 -33 38 -16 3 5 -24 68 -60 139 -36 72 -65 136
   -65 143 0 6 12 24 26 40 l27 27 -28 36 c-15 20 -25 38 -24 39 12 10 72 37 75
   33 2 -2 15 -41 29 -87 14 -47 29 -88 34 -93 14 -14 33 2 27 21 -5 15 3 17 64
   17 43 0 69 -4 67 -10 -2 -5 -17 -56 -33 -112 -16 -57 -32 -103 -35 -103 -3 0
   -12 25 -19 55 -16 66 -34 95 -49 79 -16 -15 49 -229 69 -229 11 0 34 63 80
   220 36 121 68 226 71 234 4 11 11 11 39 -4 19 -10 37 -19 39 -21 1 -1 -9 -19
   -24 -39 l-28 -36 27 -27 c14 -16 26 -34 26 -40 0 -7 -29 -71 -65 -143 -61
   -120 -69 -149 -44 -149 11 0 149 274 149 297 0 9 -9 26 -20 38 -20 22 -19 55
   2 55 32 0 152 -44 175 -64 28 -24 28 -26 33 -173 4 -123 8 -148 20 -148 12 0
   16 21 18 120 4 149 -1 177 -39 220 -24 27 -48 40 -102 56 -44 12 -80 29 -92
   44 -11 12 -39 32 -62 44 -37 18 -43 26 -43 52 0 21 8 37 25 51 32 25 85 116
   85 146 0 15 6 22 20 22 26 0 70 43 70 68 0 11 -9 31 -20 45 -17 22 -20 40 -20
   139 0 153 -27 204 -121 228 -19 5 -52 15 -74 24 -44 17 -138 19 -200 5z m191
   -39 c14 -6 40 -25 56 -42 29 -32 30 -32 45 -13 14 20 15 19 39 -8 23 -26 24
   -35 24 -148 0 -109 -2 -120 -17 -117 -13 2 -20 17 -24 49 -7 49 -38 118 -62
   138 -12 10 -28 9 -79 -5 -79 -21 -221 -24 -268 -5 -40 16 -100 58 -100 70 0 7
   167 76 205 84 41 9 154 7 181 -3z m-301 -182 c56 -23 181 -27 250 -10 98 25
   91 26 114 -21 12 -24 21 -59 21 -78 1 -48 22 -72 72 -78 34 -5 44 -10 46 -27
   4 -25 -24 -40 -44 -23 -21 17 -31 4 -38 -50 -8 -60 -49 -124 -105 -162 -141
   -94 -345 -4 -367 162 -7 54 -17 67 -39 49 -21 -18 -47 -4 -43 22 2 19 11 24
   46 29 56 7 73 30 69 94 -1 37 -6 50 -17 50 -11 0 -16 -14 -20 -50 -4 -37 -9
   -51 -22 -53 -16 -3 -18 6 -18 71 0 89 6 111 29 101 9 -3 39 -16 66 -26z m245
   -516 l60 15 0 -24 c0 -13 -7 -50 -16 -82 -19 -66 -38 -81 -104 -81 -66 0 -85
   15 -104 81 -9 32 -16 69 -16 82 l0 24 60 -15 c53 -13 67 -13 120 0z m-352
   -424 c9 -9 15 -9 24 0 7 7 25 12 40 12 26 0 28 -3 28 -40 l0 -40 -80 0 -80 0
   0 40 c0 37 2 40 28 40 15 0 33 -5 40 -12z"
        />
        <path
          d="M485 930 c-11 -18 10 -32 41 -28 40 4 38 32 -3 36 -17 2 -34 -2 -38
   -8z"
        />
        <path
          d="M725 930 c-11 -18 10 -32 41 -28 40 4 38 32 -3 36 -17 2 -34 -2 -38
   -8z"
        />
        <path d="M504 866 c-8 -22 3 -49 19 -43 6 2 12 14 12 27 0 27 -22 39 -31 16z" />
        <path d="M744 866 c-8 -22 3 -49 19 -43 6 2 12 14 12 27 0 27 -22 39 -31 16z" />
        <path
          d="M565 731 c-10 -17 3 -30 43 -42 31 -9 45 -8 76 5 38 16 46 44 10 37
   -34 -6 -89 -5 -105 3 -10 4 -20 3 -24 -3z"
        />
        <path
          d="M957 194 c-4 -4 -7 -15 -7 -25 0 -11 -9 -19 -22 -21 -29 -4 -30 -32
   -1 -36 14 -2 23 -11 25 -25 4 -29 32 -29 36 0 2 14 11 23 25 25 12 2 22 10 22
   18 0 8 -10 16 -22 18 -13 2 -23 12 -25 24 -3 22 -19 33 -31 22z"
        />
      </g>
    </svg>
  );
};

export const SubjectIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="26"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
        fill="#3571ff"
        stroke="none"
      >
        <path
          d="M54 1262 c-50 -32 -56 -59 -52 -261 l3 -183 31 -28 c18 -16 50 -31
73 -35 38 -6 41 -9 41 -39 0 -23 -6 -34 -22 -41 -34 -15 -36 -53 -4 -65 l26
-10 0 -152 c0 -84 4 -169 10 -187 13 -46 75 -109 120 -121 19 -5 54 -10 76
-10 l42 0 4 -56 c3 -33 11 -60 19 -65 8 -5 199 -9 425 -9 350 0 413 2 424 15
8 10 11 55 8 157 -3 119 -7 151 -24 189 -42 91 -130 154 -234 166 -47 5 -50 7
-50 35 0 20 9 37 30 55 34 28 64 81 74 129 6 26 13 33 41 38 50 10 85 56 85
113 0 39 -5 50 -35 79 -31 29 -35 38 -35 86 0 78 -15 119 -58 161 -50 49 -83
57 -237 57 -149 0 -194 -14 -239 -72 -26 -34 -46 -110 -46 -173 0 -24 -9 -42
-35 -68 -39 -39 -45 -78 -20 -127 16 -32 61 -60 95 -60 15 0 20 -6 20 -25 0
-37 33 -97 75 -136 23 -22 35 -43 35 -60 0 -24 -4 -27 -54 -32 -96 -10 -187
-72 -232 -158 -9 -18 -20 -61 -25 -97 -5 -36 -11 -68 -14 -70 -2 -2 -27 -1
-56 3 -39 5 -61 15 -81 35 l-28 28 0 166 c0 155 1 166 20 176 27 14 27 60 0
67 -15 4 -20 14 -20 39 0 32 2 34 41 40 54 9 88 39 99 89 12 51 12 288 0 339
-5 22 -20 51 -35 65 -24 24 -32 26 -138 29 -96 2 -116 0 -143 -16z m240 -78
c3 -9 6 -24 6 -35 0 -18 -8 -19 -110 -19 l-110 0 0 28 c0 16 3 32 7 35 3 4 50
7 104 7 79 0 98 -3 103 -16z m727 -13 c26 -27 29 -36 29 -96 0 -50 -3 -64 -12
-59 -7 4 -39 25 -70 46 -69 46 -90 47 -118 8 -30 -43 -71 -60 -152 -67 l-70
-6 4 73 c3 67 6 75 36 101 l32 29 146 0 146 0 29 -29z m-721 -219 c0 -63 -4
-102 -12 -110 -13 -13 -163 -17 -192 -6 -13 5 -16 25 -16 110 l0 104 110 0
110 0 0 -98z m657 27 l45 -31 -4 -114 -3 -113 -34 -35 c-62 -63 -149 -73 -215
-22 -50 38 -66 80 -66 180 l0 86 48 0 c49 0 138 36 162 65 16 19 14 20 67 -16z
m-357 -89 c0 -38 -2 -40 -20 -30 -31 17 -26 70 7 70 9 0 13 -13 13 -40z m520
25 c16 -19 4 -52 -20 -58 -17 -4 -20 0 -20 34 0 41 17 52 40 24z m-230 -399
c0 -69 -39 -97 -80 -56 -13 13 -20 33 -20 60 l0 40 50 0 50 0 0 -44z m-152
-91 c17 -37 67 -58 121 -52 37 4 52 12 77 41 27 31 37 36 73 36 70 0 137 -43
172 -112 15 -30 19 -59 19 -153 l0 -115 -360 0 -360 0 0 108 c0 119 14 164 66
216 39 38 79 55 135 56 39 0 47 -4 57 -25z"
        />
      </g>
    </svg>
  );
};
